import Vue from 'vue'
import createAuth0Client from '@auth0/auth0-spa-js'
// import useUsers from '@/composables/useUsers'

/** Define a default action to perform after authentication */
const DEFAULT_REDIRECT_CALLBACK = () => window.history.replaceState({}, document.title, window.location.pathname)

/** Returns the current instance of the SDK */
let instance
export const getInstance = () => instance

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance

  // The 'instance' is simply a Vue object
  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        token: null,
        user: {},
        claims: {},
        auth0Client: null,
        popupOpen: false,
        error: null,
        apiUrl: process.env.VUE_APP_AUTH0_API_URL,
      }
    },
    /** Use this lifecycle method to instantiate the SDK client */
    async created() {
      // Create a new instance of the SDK client using members of the given options object
      this.auth0Client = await createAuth0Client({
        ...options,
        client_id: options.clientId,
        redirect_uri: redirectUri,
      })

      try {
        // If the user is returning to the app after authentication..
        if (
          window.location.search.includes('code=')
          && window.location.search.includes('state=')
        ) {
          // handle the redirect and retrieve tokens
          const { appState } = await this.auth0Client.handleRedirectCallback()

          this.error = null

          // Notify subscribers that the redirect callback has happened, passing the appState
          // (useful for retrieving any pre-authentication state)
          onRedirectCallback(appState)
        }
      } catch (e) {
        this.error = e
      } finally {
        // Initialize our internal authentication state

        this.isAuthenticated = await this.auth0Client.isAuthenticated()
        if (this.isAuthenticated) {
          // get and store ID Token for Hasura
          console.log('auth01', this.auth0Client)
          this.token = await this.auth0Client.getTokenSilently()
          this.user = await this.auth0Client.getUser()
          const temp = await this.auth0Client.getIdTokenClaims()
          this.user.claims = temp['https://www.mlforex.com']
          localStorage.setItem('authId', this.user.sub)
          localStorage.setItem('authToken', this.token)
        }
        this.loading = false
      }
    },
    methods: {
      /** Handles the callback when logging in using a redirect */
      async getUser() {
        return this.auth0Client.getUser()
      },
      /** Authenticates the user using the redirect method */
      loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o)
      },
      /** Returns all the claims present in the ID token */
      getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o)
      },
      /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
      async getTokenSilently() {
        return this.auth0Client.getTokenSilently()
      },
      /** Logs the user out and removes their session on the authorization server */
      logout(o) {
        return this.auth0Client.logout(o)
      },
    },
  })

  return instance
}
